module.exports = __webpack_public_path__ + "2ac7bfd81f0399c5fe8f4f165bb5de56.svg";